import { Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { ChiSiamoComponent } from './components/chi-siamo/chi-siamo.component';
import { CorsiComponent } from './components/servizi/corsi/corsi.component';
import { GalleriaComponent } from './components/galleria/galleria.component';
import { ContattaciComponent } from './components/contattaci/contattaci.component';
import { SalaPesiComponent } from './components/servizi/sala-pesi/sala-pesi.component';
import { PersonalTrainingComponent } from './components/servizi/personal-training/personal-training.component';
import { IntegratoriComponent } from './components/servizi/integratori/integratori.component';
import { TeamComponent } from './components/team/team.component';
import { ServiziComponent } from './components/servizi/servizi.component';
import { NutrizionistaComponent } from './components/servizi/nutrizionista/nutrizionista.component';
import { FisioterapistaComponent } from './components/servizi/fisioterapista/fisioterapista.component';
import { SediComponent } from './components/sedi/sedi.component';

export const routes: Routes = [
  // Home
  { path: 'home', component: HomeComponent,  data: { breadcrumb: 'Home' } },
  { path: 'chi-siamo', component: ChiSiamoComponent,  data: { breadcrumb: 'Chi siamo' } },
  { path: 'team', component: TeamComponent,  data: { breadcrumb: 'Team' } },
  { path: 'sedi', component: SediComponent,  data: { breadcrumb: 'Sedi' } },
  { path: 'galleria', component: GalleriaComponent },
  { path: 'contattaci', component: ContattaciComponent },
  { path: 'servizi', component: ServiziComponent },
  { path: 'corsi', component: CorsiComponent },
  { path: 'sala-pesi', component: SalaPesiComponent },
  { path: 'pt', component: PersonalTrainingComponent },
  { path: 'integratori', component: IntegratoriComponent },
  { path: 'nutrizionista', component: NutrizionistaComponent },
  { path: 'fisioterapista', component: FisioterapistaComponent },


  // fallback alla home
  { path: '**', redirectTo: '/home', pathMatch: 'full' },
];
